<template>
  <div class="offset-line" :class="[offsetBottom ? 'offset-bottom' : '']" />
</template>

<script>
export default {
  props: {
    offsetBottom: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.offset-line {
  height: 8px;
  width: 100%;
  background: #f5f7fa;
}
.offset-bottom {
  margin-bottom: 24px;
}
</style>
